module.exports = __webpack_public_path__ + "img/bonus.67b9392d.png";